import type { PlainWorkflowExecution } from "@/queries/automation-queries";
import type { FC } from "react";
import { Text } from "@/components/podkit/typography/Text";
import { timeAgo } from "@/format/time";
import { Timestamp } from "@bufbuild/protobuf";
import IconCalendar2 from "central-icons/IconCalendar2";
import IconStopwatch from "central-icons/IconStopwatch";
import IconBranch from "central-icons/IconBranch";
import IconTriangleExclamation from "central-icons/IconTriangleExclamation";
import IconStopCircle from "central-icons/IconStopCircle";

type ExecutionMetricsProps = {
    execution: PlainWorkflowExecution;
    duration?: string;
    totalActionsCount: number;
};

export const ExecutionMetrics: FC<ExecutionMetricsProps> = ({ execution, duration, totalActionsCount }) => {
    return (
        <>
            <div className="flex items-center gap-1.5 min-w-0">
                <IconCalendar2 size={18} className="text-content-muted flex-shrink-0" />
                <Text className="text-base text-content-strong whitespace-nowrap">
                    {execution.metadata?.startedAt ? (
                        timeAgo(new Timestamp(execution.metadata.startedAt).toDate())
                    ) : (
                        "-"
                    )}
                </Text>
            </div>
            <div className="flex items-center gap-1.5 min-w-0">
                <IconStopwatch size={18} className="text-content-muted flex-shrink-0" />
                <Text className="text-base text-content-strong whitespace-nowrap">
                    {duration ? (
                        <span>{duration}</span>
                    ) : execution.metadata?.startedAt ? (
                        <span>In progress</span>
                    ) : (
                        <span>-</span>
                    )}
                </Text>
            </div>
            <div className="flex items-center gap-1.5 min-w-0">
                <IconBranch size={18} className="text-content-muted flex-shrink-0" />
                <Text className="text-base text-content-strong whitespace-nowrap">{totalActionsCount} actions</Text>
            </div>
            {execution.status?.failedActionCount !== undefined && execution.status.failedActionCount > 0 && (
                <div className="flex items-center gap-1.5 min-w-0">
                    <IconTriangleExclamation size={18} className="text-content-muted flex-shrink-0" />
                    <Text className="text-base text-content-strong whitespace-nowrap">
                        {execution.status.failedActionCount} <span>errors</span>
                    </Text>
                </div>
            )}
            {execution.status?.stoppedActionCount !== undefined && execution.status.stoppedActionCount > 0 && (
                <div className="flex items-center gap-1.5 min-w-0">
                    <IconStopCircle size={18} className="text-content-muted flex-shrink-0" />
                    <Text className="text-base text-content-strong whitespace-nowrap">
                        {execution.status.stoppedActionCount} <span>stopped</span>
                    </Text>
                </div>
            )}
        </>
    );
};
